import React, {FC, useEffect, useState} from "react"
import styled, {css} from "styled-components"
import PropTypes from "prop-types"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import {H3} from "@irati/ui/src/Typography"
import FormattedMessage, {FormattedCurrency} from "@irati/utils/lang"
import {RedemptionReportDuration} from "@irati/types/generated/ops"
import {useUserSavings} from "@irati/adminReporting/hooks"
import MySavingsCard from "@irati-web/my-savings/src/components/SavingsTracker/Widgets/MySavings"
import platformTracking from "@irati-tracking/platform/platform"
import Spacing from "@irati/ui/src/Spacing"

import {Separator, StyledMenu} from "../WalletMenu/Menu"
import DesktopMenu from "../DesktopMenu"

const MySavings: FC = (_, {apps}) => {
  const {data} = useUserSavings({duration: RedemptionReportDuration.AllTime})
  const savings = data?.savings?.fixed

  const [isMenuDisplayed, setIsMenuDisplayed] = useState(false)

  useEffect(() => {
    if (isMenuDisplayed) {
      platformTracking.click("savings", {source: "header"})
    }
  }, [isMenuDisplayed])

  const toggle = () => {
    setIsMenuDisplayed((current) => !current)
  }

  if (!data) return null
  return (
    <DesktopMenu
      id="platform_header_savings_button"
      show={isMenuDisplayed}
      tooltip="My Savings"
      onClick={toggle}
      onOutsideClick={toggle}
      content={<MySavingsCard showInHeader />}>
      {/* todo: This is temporary until My Savings page will be in place. Uncomment RouterLink when ready */}
      {/*<RouterLink to="/" app={apps.MY_SAVINGS} plain onClick={() => platformTracking.click("savings", {source: "header"})}>*/}
      <StyledMenu>
        <Icon icon={IconTypes.savingsAnimated} size={28} />
        {savings?.value ? (
          <>
            <Separator />
            <Flex direction="column">
              <CustomHeader>
                <FormattedMessage id="platform.mySavings.header.copy" />
              </CustomHeader>
              <H3 as="span" marginTop={-0.5}>
                <FormattedCurrency
                  currency={savings?.currency || ""}
                  value={savings?.value || 0}
                  maximumFractionDigits={savings?.value ? 2 : 0}
                />
              </H3>
            </Flex>
          </>
        ) : (
          <Spacing marginLeft={0.5}>
            <CustomHeader>
              <FormattedMessage id="platform.mySavings.zeroState.title" />
            </CustomHeader>
          </Spacing>
        )}
      </StyledMenu>
      {/*</RouterLink>*/}
    </DesktopMenu>
  )
}

MySavings.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default MySavings

const CustomHeader = styled.span`
  ${({theme}) => css`
    font-family: ${theme.font.bold};
    font-size: 8px;
    text-transform: uppercase;
    color: ${theme.colors.greys.black};
  `}
`
